import { MetricDataSource } from "../../../../protos/golang/generated/ts2/portal/metrics";

import { SvgIconProps } from "@mui/material";
import { useTranslation } from "react-i18next";
import ElderlyIcon from "@mui/icons-material/Elderly";
import ExtensionIcon from "@mui/icons-material/Extension";
import React from "react";

export const JigsawDataSourceIcon = ({
  dataSource,
  ...props
}: {
  dataSource: MetricDataSource | undefined;
} & SvgIconProps): React.ReactNode => {
  const { t } = useTranslation();

  return dataSource === MetricDataSource.JIGSAW ? (
    <ExtensionIcon
      {...props}
      titleAccess={t("utils.metrics.jigsaw.tooltip.jigsaw")}
    />
  ) : dataSource === MetricDataSource.CLASSIC ? (
    <ElderlyIcon
      {...props}
      titleAccess={t("utils.metrics.jigsaw.tooltip.classic")}
    />
  ) : undefined;
};
